import { ReactNode } from 'react';
import { JxtEventColorsEnum } from '@jooxter/utils';

export enum BookingTypeEnum {
  Desk,
  Room,
}

export enum BookingDisplayModeEnum {
  Compact,
  Regular,
  NoPadding,
  /** A narrow column (a planning's week or month): the time small on top, the title under it, icons aside. */
  Stacked,
  /** A very narrow column (a planning's month fitting the screen): a small pill, its time only. */
  Mini,
  /** A booking filling its place in a week's narrow column: the time on one line, the title under it if it fits. */
  Block,
}

export interface IJxtCalendarEvent {
  id: string;
  mode?: BookingDisplayModeEnum;
  color: JxtEventColorsEnum;
  hours?: string;
  text: string;
  isValidated?: boolean;
  notSelected?: boolean;
  nbAttendees?: number;
  isRecurrence?: boolean;
  isDeclined?: boolean;
  optionIconsList?: string[];
  onClickEvent?: (id: string) => void;
  onClickCheckIn?: () => void;
  onClickCheckOut?: () => void;
  onClickEdit?: () => void;
  onClickDelete?: () => void;
}

export interface IWrapper {
  isValidated?: boolean;
  hatchPattern: string;
  hatchClasses: string;
  children: ReactNode;
}
